<template>
  <v-form @submit.prevent="$emit('save', popupBanner)">
    <v-card>
      <v-card-title>
        {{ $t('edit_popup_banner') }}
      </v-card-title>

      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6">
            <BaseDatepickerInput
              v-model="popupBanner.start_at"
              :error-messages="errors['start_at']"
              :label="formMixin_getRequiredFieldLabel($t('start_at'))"
              @input="formMixin_clearErrors('start_at')"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <BaseDatepickerInput
              v-model="popupBanner.end_at"
              :error-messages="errors['end_at']"
              :label="formMixin_getRequiredFieldLabel($t('end_at'))"
              @input="formMixin_clearErrors('end_at')"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="popupBanner.url_link"
              :error-messages="errors['url_link']"
              :label="$t('url_link')"
              @input="formMixin_clearErrors('url_link')"
            />
          </v-col>

          <v-col cols="12">
            <template v-if="!popupBanner.id">
              <BaseFileDropZone
                accept=".jpeg,.jpg,.bmp,.png,.gif"
                @drop="
                  onFileSelect($event);
                  formMixin_clearErrors('image');
                "
              >
                <div
                  class="drop-zone"
                  :class="errors.hasOwnProperty('image') ? 'error-outline' : ''"
                >
                  <div v-if="!popupBanner.image" class="drop-zone-message">
                    <p>{{ $t('file_drop_zone_message') }}</p>
                  </div>

                  <div v-else class="file-icon">
                    <div class="file-icon-width">
                      <v-icon x-large>mdi-file</v-icon>
                      <v-icon small class="close-icon" @click.stop="onFileRemove">mdi-close</v-icon>
                      <BaseTruncatedField :text="popupBanner.image.name" :truncatedLength="8" />
                    </div>
                  </div>
                </div>
              </BaseFileDropZone>
              <template v-for="(value, key) in errors">
                <div v-if="key.includes('image')" :key="key">
                  <div
                    v-for="(error, errorIndex) in value"
                    :key="errorIndex"
                    class="mt-2 v-messages theme--light error--text"
                  >
                    {{ error }}
                  </div>
                </div>
              </template>
            </template>

            <template v-else>
              <v-img
                v-if="popupBanner.image_path"
                :src="$backendUrl(popupBanner.image_path)"
                :alt="popupBanner.original_name"
                class="patient-story-img"
              />
            </template>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <span class="text-subtitle-2 ml-3"> * {{ $t('must_be_filled') }} </span>

        <v-spacer />

        <v-btn text color="primary" @click="$emit('cancel')">
          {{ $t('cancel') }}
        </v-btn>

        <v-btn :disabled="disabled" :loading="disabled" color="primary" text type="submit">
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import formMixin from '../mixins/form-mixin';
import BaseFileDropZone from './base/BaseFileDropZone';
import BaseDatepickerInput from './base/BaseDatepickerInput';
import BaseTruncatedField from './base/BaseTruncatedField';

export default {
  name: 'PopupBannerForm',

  components: { BaseFileDropZone, BaseDatepickerInput, BaseTruncatedField },

  mixins: [formMixin],

  props: {
    popupBanner: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onFileSelect(files) {
      this.$set(this.popupBanner, 'image', files[0]);
    },

    onFileRemove() {
      this.$set(this.popupBanner, 'image', null);
    },
  },
};
</script>

<style scoped>
.drop-zone {
  background-color: white;
  outline: 2px dashed darkgray;
  width: 95%;
  height: 100px;
  text-align: center;
  margin: auto;
  position: relative;
}
.drop-zone-message {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}
.drop-zone-message p,
.image-name {
  color: darkgray;
  margin: 0;
}
.name-box {
  width: 120px;
}
.file-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
}
.close-icon {
  position: absolute;
  right: 5px;
  cursor: pointer;
}
.file-icon-width {
  width: 86px;
  position: relative;
}
</style>
